import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { Feather } from '@expo/vector-icons';

import styles from "../styles/profileStyle";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";

type OptionCheckboxProps = {
  label?: string;
  value?: any;
  onValueChange?: any;
};

const OptionCheckbox: React.FC<OptionCheckboxProps> = ({
  label,
  value,
  onValueChange,
}) => {
  const handlePress = () => {
    if (onValueChange) {
      onValueChange(!value);
    }
  };
  return (
    <TouchableOpacity onPress={handlePress} activeOpacity={0.8}>
      <View style={styles.optionBoxInnerBox}>
        <Text style={[GlobalStyles.bodyText,{
           fontFamily: 'InterMedium', letterSpacing: -0.36, color: "#737373",
        }]}>{label}</Text>
        <View
          style={[
            {
              width: 20,
              height: 20,
              borderWidth: 1,
              borderRadius: 3,
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 8,
            },
            {
              backgroundColor: value ? "rgba(192, 164, 111, 1)" : Colors.grey100,
              borderColor: value ? "rgba(192, 164, 111, 1)" : Colors.grey200,
            },
          ]}
        >
          {value && <Feather name="check" size={20} color={Colors.white000} /> }
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default OptionCheckbox;
